import { useTranslation } from 'react-i18next';
import { NavAnchorContent } from '@/components';
// import i18n from '@/i18n/react-i18next-config';
import AppList from './AppList';
import BizIntro from './BizIntro';

// import ServiceIntro from './ServiceIntro'

export function Home() {
  return (
    <>
      <NavAnchorContent
        id="home-biz-intro"
        label={window.trans('widget-developer-platform')}
        isLink={false}
      >
        <BizIntro />
      </NavAnchorContent>
      <NavAnchorContent
        id="home-app-list"
        label={window.trans('my-app')}
        isLink={false}
      >
        <AppList />
      </NavAnchorContent>
      <div></div>
      <NavAnchorContent
        id="home-doc-centere"
        label={window.trans('doc-center')}
        isLink={true}
        link="https://dev.mi.com/console/doc/"
      ></NavAnchorContent>
      <NavAnchorContent
        id="home-mi-platform"
        label={window.trans('mi-open-platform')}
        isLink={true}
        link="https://dev.mi.com/console/"
      >
        {/* <AppList /> */}
      </NavAnchorContent>
      {/* <NavAnchorContent id="home-service-intro" label="基础服务">
        <ServiceIntro />
      </NavAnchorContent> */}
    </>
  );
}
